export default "__VITE_ASSET__DO8Ihh9b__"